export default __webpack_public_path__ + "static/media/556.a5c09cb9.jpg";